import { FloatingPanel } from "@/components/ui/floating-panel";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

function FormSectionSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-3 pb-2 border-b border-border">
        <Skeleton className="w-10 h-10 rounded-full" />
        <Skeleton className="h-6 w-40" />
      </div>
      <div className="grid gap-4">
        <div className="space-y-2">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-11 w-full rounded-xl" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-11 w-full rounded-xl" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-11 w-full rounded-xl" />
          </div>
        </div>
        <div className="space-y-2">
          <Skeleton className="h-3 w-32" />
          <Skeleton className="h-11 w-full rounded-xl" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Skeleton className="h-3 w-36" />
            <Skeleton className="h-11 w-full rounded-xl" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-11 w-full rounded-xl" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function GameFormSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn("flex flex-col section-gap-lg pb-20", className)}>
      <div className="flex flex-col items-center text-center gap-2 mb-4">
        <Skeleton className="h-10 w-48 rounded-lg" />
        <Skeleton className="h-5 w-72 max-w-full" />
      </div>

      <FloatingPanel>
        <div className="p-6 sm:p-8 space-y-10">
          <FormSectionSkeleton />
          <FormSectionSkeleton />
          <FormSectionSkeleton />

          <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t border-border">
            <Skeleton className="h-12 flex-1 rounded-xl" />
            <Skeleton className="h-12 flex-1 rounded-xl" />
          </div>
        </div>
      </FloatingPanel>
    </div>
  );
}
